import React from 'react';
import PropTypes from 'prop-types';
import { I18N } from 'commons';

const SaveAndContinueButton = ({ onClick, type, disabled, ebTestValue }) => (
  <div className="offset-md-5 col-md-7 mt-2">
    <button
      className="btn btn-primary btn-block mt-3"
      type={type}
      onClick={onClick}
      disabled={disabled}
      eb-test={ebTestValue}
    >
      <I18N>button.save&continue</I18N>
    </button>
  </div>
);

SaveAndContinueButton.propTypes = {
  onClick: PropTypes.func,
  type: PropTypes.string,
  disabled: PropTypes.bool,
  ebTestValue: PropTypes.string.isRequired,
};

SaveAndContinueButton.defaultProps = {
  onClick: () => { },
  type: 'submit',
  disabled: false,
};

export default SaveAndContinueButton;
